import { components, type DropdownIndicatorProps } from 'react-select';
import { m } from 'motion/react';
import { ChevronDown } from 'lucide-react';

import type { TOption } from '../types';

export const CustomDropdownIndicator = (props: DropdownIndicatorProps<TOption>) => {
  const { selectProps } = props;

  return (
    <components.DropdownIndicator {...props} className="group">
      <m.div
        animate={{ rotate: selectProps.menuIsOpen ? 180 : 0 }}
        transition={{ duration: 0.2, ease: 'easeInOut' }}
        className="transition-colors duration-150 text-foreground/50 group-hover:text-action"
      >
        <ChevronDown className="w-4 h-4" />
      </m.div>
    </components.DropdownIndicator>
  );
};
